import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { WindowSize } from '@domains';
import { FxLayoutAlignDirective, FxLayoutDirective, ResponsiveService } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';
import { CarouselAlignMode, CarouselComponent, CarouselConfig, CarouselSlideDirective, CarouselWidthMode } from 'ng-carousel-cdk';
import { takeUntil } from 'rxjs';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-veterans-behind-resupply-split-landing',
  templateUrl: './veterans-behind-resupply.component.html',
  styleUrl: './veterans-behind-resupply.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, StarRatingModule, MatIcon, CarouselComponent, CarouselSlideDirective],
})
export class VeteransBehindResupplySectionComponent extends BaseSectionComponent implements OnInit {
  itemIndex = 0;

  carouselConfig: CarouselConfig<{
    name: string;
    role: string;
    image: string;
    icon: string;
  }> = {
    items: [
      {
        name: 'Kathleen Huntsman',
        role: 'Sr. Customer Success Manager',
        image: 'kathleen-huntsman.jpeg',
        icon: 'air-force',
      },
      {
        name: 'Grace Kiley',
        role: 'Account Manager',
        image: 'grace-kiley.jpeg',
        icon: 'air-force',
      },
      {
        name: 'Nick Gonzalez',
        role: 'Sr. Director Of Operations',
        image: 'nick-gonzalez.jpeg',
        icon: 'army',
      },
      {
        name: 'Paul Tocci',
        role: 'CEO & Founder',
        image: 'paul-tocci.png',
        icon: 'army',
      },
      {
        name: 'Teddy Griffin',
        role: 'Sr. Director Of Customer Success',
        image: 'teddy-griffin.jpeg',
        icon: 'air-force',
      },
      {
        name: 'Daniel Dulay',
        role: 'Donor Support Manager',
        image: 'daniel-dulay.jpeg',
        icon: 'air-force',
      },
      {
        name: 'Matt Hernandez',
        role: 'Enterprise Account Manager',
        image: 'matt-hernandez.jpeg',
        icon: 'army',
      },
      {
        name: 'Josh Bell',
        role: 'Donor Specialist',
        image: 'josh-bell.jpeg',
        icon: 'marine',
      },
      {
        name: 'Brent Bethel',
        role: 'Driver Account Executive',
        image: 'brent-bethel.png',
        icon: 'army',
      },
      {
        name: 'Charles Appleby',
        role: 'Charity Partnerships Manager',
        image: 'charles-appleby.webp',
        icon: 'army',
      },
    ],
    alignMode: CarouselAlignMode.LEFT,
    widthMode: CarouselWidthMode.PX,
    slideWidth: 275,
    shouldLoop: true,
    autoplayEnabled: true,
    autoplayDelay: 5000,
  };

  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.responsiveService.size.pipe(takeUntil(this.destroy$)).subscribe((size) => {
      this.carouselConfig = {
        ...this.carouselConfig,
        alignMode: [WindowSize.LG, WindowSize.XL, WindowSize.MD].includes(size) ? CarouselAlignMode.LEFT : CarouselAlignMode.CENTER,
      };
    });
  }

  setItemIndex(newIndex: number): void {
    this.itemIndex = newIndex;
  }
}
